import React, { FC, ReactNode } from "react";
import { PresignedImage } from "@/components/common/PresignedImage";

interface ImageWithPlaceholderProps {
  placeholder: ReactNode;
  photo?: string;
  className?: string;
  alt?: string;
  tenantId?: string;
}

export const PresignedImageWithPlaceholder: FC<ImageWithPlaceholderProps> = ({
  photo,
  placeholder,
  className,
  alt,
  tenantId,
}) => {
  if (photo) {
    return (
      <PresignedImage
        className={className}
        alt={alt || "Image"}
        fileId={photo}
        tenantId={tenantId}
      />
    );
  }

  return <>{placeholder}</>;
};
